import './assign';
import './getOwnPropertySymbols';
import './getOwnPropertyDescriptors';
import './merge';
